import { createFileRoute } from '@tanstack/react-router'
import StoresPage from '@/pages/stores'

export const Route = createFileRoute('/stores')({
  component: StoresPage,
})
